<template>
  <div>
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>İzin</b-card-title>
          <b-row>
            <b-col>
              <b-table
                v-if="employeePermits.length > 0"
                responsive
                :items="employeePermits"
                :fields="permitFields"
                class="mb-0"
              >
                <template #cell(title)="data">
                  <span class="text-nowrap">
                    {{ data.value }}
                  </span>
                </template>
              </b-table>
              <p v-else>
                İzin kaydı bulunamadı.
              </p>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import {
  BRow, BCol, BCard, BCardTitle, BTable,
} from 'bootstrap-vue'

export default {
  name: 'Permits',
  components: {
    BRow,
    BCol,
    BCard,
    BCardTitle,
    BTable,
  },
  data() {
    return {
      permitFields: [
        {
          key: 'desc', label: 'Açıklama',
        },
        {
          key: 'days', label: 'Süre',
        },
        {
          key: 'startdate', label: 'Başlangıç',
        },
        {
          key: 'enddate', label: 'Bitiş',
        },
        {
          key: 'permit_type', label: 'İzin Türü',
        },
        {
          key: 'permit_status', label: 'Durum',
        },
      ],
    }
  },
  computed: {
    employeePermits() {
      return this.$store.getters['employeePermits/getEmployeePermits']
    },
  },
  created() {
    this.getEmployeePermits()
  },
  methods: {
    getEmployeePermits() {
      this.$store.dispatch('employeePermits/employeePermitsList', {
        where: {
          'employee_permits.id_employees': this.$route.params.id,
        },
      })
    },
  },
}
</script>

<style scoped>

</style>
